<template>
  <b-modal size="xl" hide-footer id="modal-besoinECS" title="Besoin ECS">
    <!-- <b-row class="mb-2"> -->
    <!-- <b-col cols="8" class="w-100"> -->
    <b-card class="mb-2 box_shadow" align="center">
      <b-row class="mb-2">
        <b-col cols="5">
          <b-row>
            <b-col cols="6">
              <h5>Typologie</h5>
            </b-col>
            <b-col cols="6">
              <h5>Besoin Ecs</h5>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="6">
          <div v-for="typology in form" :key="typology.id">
            <b-form-group
              id="fieldset-horizontal"
              content-cols="8"
              :label="typology.name"
              label-for="input-horizontal"
              label-cols-sm="4"
              label-cols-lg="4"
            >
              <!-- <b-form-input readonly plaintext> </b-form-input>
                   -->
              <b-form-input
                debounce="200"
                type="number"
                :number="true"
                @update="submitUpdate( typology.id, $event)"
                :id="typology.name"
                v-model="typology.besoinEcs"
              ></b-form-input>
            </b-form-group>
          </div>
        </b-col>
      </b-row>
    </b-card>

    <!-- <b-button block @click="submit">
      Valider
      <b-spinner v-if="isLoading" variant="warning"></b-spinner>
    </b-button> -->
  </b-modal>
</template>

<script>
// https://github.com/SortableJS/Vue.Draggable
// import draggable from "vuedraggable";

export default {
  name: "ModalBesoinECS",
  props: {},
  data() {
    return {
      form: {},
      other: 0,
      besoinECS: [],
      isLoading: false,
      edit: false,
      disabled: false,
      components: [],
      selectComponents: [],
      isDragging: false,
      typologies: [],
    };
  },
  components: {},
  mounted() {
    this.$root.$on("bv::modal::show", (bvEvent, modalId) => {
      if (modalId === "modal-besoinECS") {
        this.getTypologies();
        this.getBesoinEcs();
      }
    });
    this.$root.$on("bv::modal::hidden", (bvEvent, modalId) => {
      if (modalId === "modal-besoinECS") {
        this.form = [];
        this.getTypologies();
        this.getBesoinEcs();
      }
    });
  },
  methods: {
    async getTypologies() {
      await fetch(
        process.env.VUE_APP_API_BASE_URL + "/api/v1/typology/getAllTypologies",
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.localStorage.token}`
          },
        }
      )
        .then((res) => res.json())
        .then((rep) => {

          this.typologies = rep
            // .map((item) => {
            //   item.value = item;
            //   item.text = item.name;
            //   return { ...item };
            // })
            // .sort((a, b) => a.name.localeCompare(b.name));
        });
    },
    groupBy(array, f) {
      const groups = {};
      array.forEach((o) => {
        const group = JSON.stringify(f(o));
        groups[group] = groups[group] || [];
        groups[group].push(o);
      });
      return Object.keys(groups).map((group) => groups[group]);
    },
    getBesoinEcs() {
      // console.log(this.form);
      fetch(
        process.env.VUE_APP_API_BASE_URL +
          "/api/v1/buildingCaracteristics/getBesoinEcs",
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.localStorage.token}`
          },
        }
      )
        .then((res) => res.json())
        .then((rep) => {

          this.form = this.typologies.map((item)=> {
            const obj = {...item}
            obj.besoinEcs = rep.find((typo)=> typo.id === item.id)?.besoinEcs || 0;

            return obj;
          }).sort((a, b) => a.name.localeCompare(b.name))
          // this.form = rep.caracteristics;
        });
    },
    submitUpdate(typologyId, event) {
      console.log(typologyId);
      console.log(event);
      this.isLoading = true;

      fetch(
        process.env.VUE_APP_API_BASE_URL +
          "/api/v1/buildingCaracteristics/saveBesoinEcs",
        {
          method: "POST",
          body: JSON.stringify({
            id: typologyId, besoinEcs: event
          }),
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.localStorage.token}`
          },
        }
      )
        .then((res) => res.json())
        .then((rep) => {
          this.isLoading = false;
          console.log(rep);
          this.success = true;
        });
    },
  },
};
</script>
<style>
.w_45 {
  width: 45%;
}
.box_shadow {
  box-shadow: black 0px 0px 16px -6px;
}

.flip-list-move {
  transition: transform 0.5s;
}
.no-move {
  transition: transform 0s;
}

.list-group {
  min-height: 20px;
}
.list-group-item {
  cursor: move;
}
.list-group-item i {
  cursor: pointer;
}
.ghost {
  opacity: 0.5;
  background: red;
}
.chosen {
  opacity: 0.5;
  background-color: orange !important;
}
.drag {
  opacity: 0.5;
  background: green;
}
.sticky {
  position: sticky;
  top: 0;
}

.sortable-selected {
  background-color: orange !important;
}
</style>
